import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { generalStore } from '../../store';
import { useTranslation } from 'react-i18next';

import Accordion from '../accordion/Accordion';
import Loader from '../loader/Loader';

import { RESPONSE } from '../../js/_constants';

import './SupportList.scss';

type Faqs = {
  '@id': string;
  answer: string;
  category: string;
  enabled: boolean;
  position: number;
  question: string;
  language: string;
};

const SupportList = () => {
  const { getFAQs, faqs } = generalStore();
  const [isLoading, setIsLoading] = useState(true);
  const [support, setSupport] = useState<Faqs[]>([]);
  const { t, i18n } = useTranslation();

  const compare = (a, b) => {
    if (a.position < b.position) {
      return -1;
    }
    if (a.position > b.position) {
      return 1;
    }
    return 0;
  };

  useEffect(() => {
    setIsLoading(true);
  }, []);

  useEffect(() => {
    setSupport(faqs.sort(compare).filter(faq => faq.enabled));
    setIsLoading(false);
  }, [faqs]);

  useEffect(() => {
    setIsLoading(true);
    getFAQs(i18n.language);
  }, [i18n.language]);

  return (
    <div className="b-support-list">
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <p>
            {t('support_description1')}
            <br />
            {t('support_description2')}
          </p>
          <h5>FAQ</h5>
          {support.map((entry,i) => (
            <Accordion name={`faq-question-${i + 1}`} title={entry.question} key={entry[RESPONSE.ID]}>
              {
                <ul data-testId={`faq-answer-${i + 1}`} >
                  {entry.answer.split('/').map((answer) => (
                    <li key={uuidv4()}>{answer}</li>
                  ))}
                </ul>
              }
            </Accordion>
          ))}
        </>
      )}
    </div>
  );
};

export default SupportList;
